import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/justificaciones/';

/**
 * GET Justificaciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getJustificaciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Justificación
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getJustificacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Justificación
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJustificacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Justificación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJustificacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Justificación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteJustificacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
